import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import {
  getClustersQueryKey,
  getClusterQueryKey,
} from '@cast/shared-cluster-context-data-access';

export const useReconcileClusterMutation = (clusterId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => apiClient.clusters.reconcileCluster({ clusterId }),
    onSuccess: () => {
      notify.success('Reconciliation in progress');
      queryClient.invalidateQueries({
        queryKey: getClusterQueryKey({ id: clusterId }),
      });
      queryClient.invalidateQueries({
        queryKey: getClustersQueryKey({}),
      });
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
